import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import RewardsPolicySection from './RewardsPolicySection';
import './RewardsPolicy.css';

function RewardsPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rewards-page">
      <button className="back-button" onClick={() => navigate('/')} aria-label="Go back to home">
        <FaArrowLeft /> Back
      </button>
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <img src={process.env.PUBLIC_URL + '/rskpay-logo.png'} alt="RSKPay" />
            <span>RSKPay</span>
          </div>
          <input id="nav-toggle" className="nav-toggle" type="checkbox" aria-label="Toggle navigation" />
          <label htmlFor="nav-toggle" className="nav-hamburger" aria-hidden="false">
            <span></span>
            <span></span>
            <span></span>
          </label>
          <ul className="nav-menu">
            <li><a href="/">Home</a></li>
            <li><a href="/#about">About</a></li>
            <li><a href="/#services">Services</a></li>
            <li><a href="/#features">Features</a></li>
          </ul>
        </div>
      </nav>


      <div className="rewards-page-content">
        <div className="policy-container">
          <RewardsPolicySection />
        </div>
      </div>
    </div>
  );
}

export default RewardsPolicy;
